import { authenticatedHandler } from '../../clients/handlers/authenticated.mjs';
import { composeServiceApi } from '../../clients/internal/composeServiceApi.mjs';
import { extendedEncodeURIComponent } from '../../clients/middleware/signing/utils/extendedEncodeURIComponent.mjs';
import { parseMetadata } from '../../clients/serde/responseInfo.mjs';
import { parseJsonError, parseJsonBody } from '../../clients/serde/json.mjs';
import { AmplifyUrl } from '../../utils/amplifyUrl/index.mjs';
import { defaultConfig, getSharedHeaders } from './base.mjs';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const updateEndpointSerializer = ({ ApplicationId = '', EndpointId = '', EndpointRequest }, endpoint) => {
    const headers = getSharedHeaders();
    const url = new AmplifyUrl(endpoint.url);
    url.pathname = `v1/apps/${extendedEncodeURIComponent(ApplicationId)}/endpoints/${extendedEncodeURIComponent(EndpointId)}`;
    const body = JSON.stringify(EndpointRequest);
    return { method: 'PUT', headers, url, body };
};
const updateEndpointDeserializer = async (response) => {
    if (response.statusCode >= 300) {
        const error = await parseJsonError(response);
        throw error;
    }
    else {
        const { Message, RequestID } = await parseJsonBody(response);
        return {
            MessageBody: {
                Message,
                RequestID,
            },
            $metadata: parseMetadata(response),
        };
    }
};
/**
 * @internal
 */
const updateEndpoint = composeServiceApi(authenticatedHandler, updateEndpointSerializer, updateEndpointDeserializer, defaultConfig);

export { updateEndpoint };
//# sourceMappingURL=updateEndpoint.mjs.map
